import { api } from '../lib/gapApi';

export const getAnalysisEvidence = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/evidence`);
  return response.data;
};

export const getAnalysisCollectors = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/collectors`);
  return response.data;
};

export const getAnalysisProgress = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/progress`);
  return response.data;
};
